import React from 'react'
import "./UnauthorizedPage.css"
function
UnauthorizedPage() {
  return (
    <div className='unAuthorizedBox'>
        403 UNAUTHORIZED
    </div>
  )
}


export default UnauthorizedPage